<ion-header>
   <ion-toolbar>
       <ion-title>{{autocompleteTextMap[type]}}</ion-title>
       <ion-buttons slot="end">
           <ion-button (click)="cancel()" size="large">
               <ion-icon name="close-circle-outline" ></ion-icon>
           </ion-button>
       </ion-buttons>
   </ion-toolbar>
</ion-header>

<ion-content class="athletex-theme">
   <form [formGroup]="form" autocomplete="off" class="form-container">

       <ion-list lines="none" class="w-100 p-1 mt-3">

           <ion-item class="input-container" style="--padding-start: 0; --inner-padding-end: 0;">
               <ion-searchbar search-icon="search-circle"
                   [formControlName]="'selectedName'"
                   [placeholder]="placeholder"
                   #searchbar
                   mode="md">
               </ion-searchbar>
           </ion-item>

           <ion-item *ngFor="let item of autocompleteItems" (click)="onItemClick(item)">
               <ion-label>
                    <span>{{item.name}}</span>
                    <span *ngIf="item.city && item.state"class="city-info"> ({{item.city}}, {{item.state}})</span>
                </ion-label>
               <ion-badge
                   *ngIf="!item.id"
                   slot="start"
                   color="medium">
                   Create new
               </ion-badge>
           </ion-item>

       </ion-list>

   </form>
</ion-content>
